/*
 * AVB – Downloads (Produktseite)
 *
 * Shopify-Liquid liefert fuer Datei-Referenz-Metafelder keine Dateigroesse.
 * Dieses Skript holt sie per HEAD-Request aus dem Content-Length-Header der
 * CDN-Datei nach. Klappt das nicht (kein CORS-Header, Netzwerkfehler, kein
 * Content-Length), bleibt der Platzhalter ausgeblendet – der Download-Link
 * funktioniert unabhaengig davon.
 */
(function () {
  var nodes = document.querySelectorAll('[data-avb-download-size]');
  if (!nodes.length || typeof window.fetch !== 'function') return;

  function formatSize(bytes) {
    if (!bytes || bytes < 1) return '';
    if (bytes >= 1048576) {
      return (bytes / 1048576).toFixed(1).replace('.', ',') + ' MB';
    }
    return Math.max(1, Math.round(bytes / 1024)) + ' KB';
  }

  Array.prototype.forEach.call(nodes, function (node) {
    var url = node.getAttribute('data-avb-download-size');
    if (!url) return;

    fetch(url, { method: 'HEAD' })
      .then(function (response) {
        if (!response.ok) return;
        var label = formatSize(parseInt(response.headers.get('content-length'), 10));
        if (!label) return;
        node.textContent = label;
        node.hidden = false;
      })
      .catch(function () {
        /* Groesse bleibt ausgeblendet */
      });
  });
})();
